var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 86,
    viewBox: "0 0 103 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4349_37810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6305 3.57282C67.1839 1.33981 65.3975 0 63.1645 0H44.8538L45.747 13.3981H35.0286L35.9218 0H17.1645C14.9315 0 13.1451 1.78641 12.6985 3.57282L0.640198 66.0971C0.193596 68.7767 2.42661 71.4563 5.10622 71.4563H31.4557L32.7955 49.1262H47.98L49.3198 71.4563H75.2227C77.9023 71.4563 80.1354 68.7767 79.6888 66.0971L67.6305 3.57282ZM33.2421 40.1942L34.1353 22.3301H45.747L46.6402 40.1942H33.2421Z",
    fill: "#C7D1DA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0003 34.668C62.1203 34.668 51.667 45.1213 51.667 58.0013C51.667 70.8813 62.1203 81.3346 75.0003 81.3346C87.8803 81.3346 98.3337 70.8813 98.3337 58.0013C98.3337 45.1213 87.8803 34.668 75.0003 34.668ZM86.667 60.3346H63.3337V55.668H86.667V60.3346Z",
    fill: "#8A8F9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4349_37810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 71.4563,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadError);
export default __webpack_public_path__ + "static/media/RoadError.6894d2ef176da4166a4cc0b47fa480a3.svg";
export { ForwardRef as ReactComponent };